module.exports = __webpack_public_path__ + "img/hotelbalmoral.64c15137.jpg";